import { outerLayoutMixinPropsType, } from "../../mixins/outerLayout";
export const selectBoxOptionPropsType = outerLayoutMixinPropsType.complete({
    logo: true,
    description: true,
    disabled: true,
    marked: true,
    additionalInfo: true,
    icon: true,
    title: true,
    selected: true,
    clickAction: true,
    children: true,
    className: true,
    tooltip: true,
    hideCheckmarks: true,
    _internal: true,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9TZWxlY3RCb3gvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTUEsT0FBTyxFQUVMLHlCQUF5QixHQUMxQixNQUFNLDBCQUEwQixDQUFDO0FBb0NsQyxNQUFNLENBQUMsTUFBTSx3QkFBd0IsR0FDbkMseUJBQXlCLENBQUMsUUFBUSxDQUF1QjtJQUN2RCxJQUFJLEVBQUUsSUFBSTtJQUNWLFdBQVcsRUFBRSxJQUFJO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsTUFBTSxFQUFFLElBQUk7SUFDWixjQUFjLEVBQUUsSUFBSTtJQUNwQixJQUFJLEVBQUUsSUFBSTtJQUNWLEtBQUssRUFBRSxJQUFJO0lBQ1gsUUFBUSxFQUFFLElBQUk7SUFDZCxXQUFXLEVBQUUsSUFBSTtJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLFNBQVMsRUFBRSxJQUFJO0lBQ2YsT0FBTyxFQUFFLElBQUk7SUFDYixjQUFjLEVBQUUsSUFBSTtJQUNwQixTQUFTLEVBQUUsSUFBSTtDQUNoQixDQUFDLENBQUMifQ==